import { Component, OnInit, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { NotificationService } from '../../../services/notification.service';
import { Document } from './../../../interfaces/graph-types';
import {
  trigger,
  style,
  transition,
  animate,
  keyframes,
  query,
  stagger,
} from '@angular/animations';
import { WatchAccountService } from '../../../services/watch-account.service';

@Component({
  selector: 'notifications-info',
  template: require('./notifications-info.component.pug'),
  styles: [require('./notifications-info.component.css').toString()],
  animations: [
    trigger('listAnimation', [
      transition('* => *', [
        query(':enter', style({ opacity: 0 }), { optional: true }),

        query(
          ':enter',
          stagger('100ms', [
            animate(
              '0.4s ease-in',
              keyframes([
                style({
                  opacity: 0,
                  transform: 'translateY(+100%)',
                  offset: 0,
                }),
                style({ opacity: 1, transform: 'translateY(0)', offset: 1.0 }),
              ]),
            ),
          ]),
          { optional: true },
        ),
      ]),
    ]),
  ],
})
export class NotificationsInfoComponent implements OnInit {
  @Input()
  open: Subject<boolean>;

  @Input()
  accountId: string;

  candidateSubjectId: Subject<string>;

  sub: any = null;
  opensub: any = null;

  rightPercent = '-100%';
  backdrop = 'none';

  private allNotifications = [];

  typeClasses = {
    open: 'badge-info',
    click: 'badge-warning',
    unsubscribe: 'badge-unsub',
    import: 'badge-primary',
    default: 'badge-secondary',
  };

  // -------------------------------------------------------------------
  constructor(
    private notificationService: NotificationService,
    private watch: WatchAccountService,
  ) {
    this.candidateSubjectId = new Subject<string>();
  }

  // -------------------------------------------------------------------
  ngOnInit() {
    this.opensub = this.open.subscribe(value => {
      if (value) {
        this.rightPercent = '0%';
        this.backdrop = 'block';
      } else {
        // no notifications, close
        this.closePanel();
      }
    });

    this.sub = this.notificationService.notifications$.subscribe(
      notifications => {
        this.allNotifications = notifications;
        if (this.allNotifications.length == 0) {
          // no notifications, close
          this.clickclose();
        }
      },
    );
  }

  // -------------------------------------------------------------------
  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    if (this.opensub) {
      this.opensub.unsubscribe();
    }
  }

  // -------------------------------------------------------------------
  clickclose() {
    this.open.next(false);
  }

  // -------------------------------------------------------------------
  closePanel() {
    this.rightPercent = '-100%';
    this.backdrop = 'none';
  }

  // -------------------------------------------------------------------
  getAccountId() {
    return this.watch.accountId().getValue();
  }

  viewingCandidate: string;
  // -------------------------------------------------------------------
  selectCandidateInfo(candidateId) {
    this.viewingCandidate = candidateId;
    this.candidateSubjectId.next(candidateId);
  }

  // -------------------------------------------------------------------
  closeCandidateInfo() {
    this.viewingCandidate = null;
  }

  // -------------------------------------------------------------------
  public trackByDocumentId(index: number, doc: Document): Document['id'] {
    return doc.id; // unique id corresponding to the item
  }
}
